<span id="{{ 'radio' + item.key }}" *ngFor="let item of to.options" class="radio1 cursor-pointer radioClassAll" 
    [ngClass]="{'radioSelected': currentSelection == item.key }" (click)="onClick(item)">
    {{ item.value }}
</span>